import { render } from "./ClientDetect.vue?vue&type=template&id=2a45076f&scoped=true"
import script from "./ClientDetect.vue?vue&type=script&lang=js"
export * from "./ClientDetect.vue?vue&type=script&lang=js"

import "./ClientDetect.vue?vue&type=style&index=0&id=2a45076f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a45076f"]])

export default __exports__